var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "55px",
    viewBox: "0 0 56 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-513.000000, -1184.000000)",
    stroke: "#004AD1",
    strokeWidth: 0.913846154
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(504.000000, 1175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(9.926471, 10.434783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2251272,33.4309313 C22.2251272,33.4309313 18.7158966,32.2781405 18.7158966,26.5141869 C16.7834803,26.5141869 16.7834803,21.9030239 18.7158966,21.9030239 C18.7158966,21.1306541 15.206666,12.6806981 21.0553837,13.8334888 C22.2251272,9.22232587 35.0923062,9.22232587 36.2620497,13.8334888 C37.072682,17.0324831 35.0923062,21.3370037 35.0923062,21.9030239 C37.0247225,21.9030239 37.0247225,26.5141869 35.0923062,26.5141869 C35.0923062,32.2781405 31.5830755,33.4309313 31.5830755,33.4309313 L31.5830755,39.1948849 C37.377985,41.3356173 43.1155771,43.1097623 46.0539729,45.1317572 C50.8475819,40.3442173 53.8082028,33.7710045 53.8082028,26.5141869 C53.8082028,11.8702862 41.7621838,0 26.9041014,0 C12.0448492,0 0,11.8702862 0,26.5141869 C0,33.784838 2.97114859,40.3695787 7.77879453,45.1594242 C10.8903123,43.0382893 17.0256172,41.1327262 22.2251272,39.1948849 L22.2251272,33.4309313 L22.2251272,33.4309313 Z",
    id: "Stroke-1703",
    fill: "#004AD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77926243,45.1591936 C12.657093,50.0170538 19.4217199,53.0281432 26.9045693,53.0281432 C34.3991161,53.0281432 41.1754405,50.0055259 46.0544408,45.1326795",
    id: "Stroke-1704"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.228e83ea2c6e56d5ce4a4e7bf02bd65f.svg";
export { ForwardRef as ReactComponent };